import {BaseDataSource, QueryResultsModel} from "../../_base/crud";
import {select, Store} from "@ngrx/store";
import {AppState} from "../../reducers";
import {
    selectPOSsInStore,
    selectPOSsPageLoading,
    selectPOSsShowInitWaitingMessage
} from "../ek-selectors/point-of-sale.selector";

export class PointOfSaleDatasource extends BaseDataSource {
    constructor(private store: Store<AppState>) {
        super();
        this.loading$ = this.store.pipe(
            select(selectPOSsPageLoading),
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectPOSsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectPOSsInStore),
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });
    }
}
